module.exports = __webpack_public_path__ + "static/media/(H)-Prata-08.b3b23ddd.jpg";